import { AText, Box } from '@alf/uikit';
import { useGetImage } from '@namespace/themes';

import styles from './index.module.css';

export const LicenseSection = () => {
  const getImg = useGetImage();
  const adultsOnlyIconLight = '/images/adultsOnly/18+.svg';
  const adultsOnlyIconDark = '/images/adultsOnly/18+Dark.svg';
  const adultsOnlyIcon = getImg(adultsOnlyIconLight, adultsOnlyIconDark);

  return (
    <Box direction="column" gap="ms" top="ms">
      <Box className={styles.divider} />

      <Box gap="m" align="center" justify="center">
        <img src={adultsOnlyIcon} alt="18+" />

        <img src="/images/onin.svg" alt="onin" />

        <AText className={styles.license}>License: L1200662W001197</AText>
      </Box>
    </Box>
  );
};
